import { useEffect, useState } from "react";
import { fetchTickers, type TickersPayload } from "../api/tickers.js";

const REFRESH_MS = 60_000;

export function useTickers(enabled: boolean): TickersPayload | null {
  const [data, setData] = useState<TickersPayload | null>(null);

  useEffect(() => {
    if (!enabled) return;

    function refresh() {
      fetchTickers()
        .then(setData)
        .catch((err) => console.error("tickers fetch failed", err));
    }

    refresh();
    const id = setInterval(refresh, REFRESH_MS);
    return () => clearInterval(id);
  }, [enabled]);

  return data;
}
